import React, { forwardRef } from 'react';
import { getSuggestionOptionAriaProps } from '../utils/search-suggestions-aria';

type SuggestionListItemOptionProps = React.PropsWithChildren<{
  elementIndex: number;
  navigationIndex: number;
}>;

export const SuggestionListItemOption = forwardRef<HTMLDivElement, SuggestionListItemOptionProps>(
  ({ elementIndex, navigationIndex, children }, ref) => (
    <div
      ref={ref}
      {...getSuggestionOptionAriaProps(elementIndex, navigationIndex)}
      data-qa-header-search-suggestion=""
    >
      {children}
    </div>
  ),
);

SuggestionListItemOption.displayName = 'SuggestionListItemOption';
